import { combineReducers } from '@reduxjs/toolkit'
import alertsReducer from './alertsSlice'
import alertsProfileReducer from './alertsProfileSlice'
import monitoringGroupUnprocessedReducer from './monitoringGroupUnprocessedSlice'
import monitoringLogsReducer from './monitoringLogsSlice'
import monitoringStatisticsReducer from './monitoringStatisticsSlice'

// 合并 alerts 模块下的所有 reducer
const alertsStore = combineReducers({
  // 统一的 alerts slice（使用 switchPayload）
  alerts: alertsReducer,
  // 预警明细 slice
  alertsProfile: alertsProfileReducer,
  // 监控未处理分组（Java，进入服务预警页加载一次）
  monitoringGroupUnprocessed: monitoringGroupUnprocessedReducer,
  monitoringStatistics: monitoringStatisticsReducer,
  // 监控 Webhook 推送记录列表
  monitoringLogs: monitoringLogsReducer
})

export default alertsStore
